<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/ItemMasterTableview"></BacktoPage>
          <Headerlayout :headertext="EditId
            ? $t('Items.ItemMaster.EditFormHeader')
            : $t('Items.ItemMaster.FormHeader')
            " :contenttext="$t('Items.ItemMaster.FormHeaderContent')">
          </Headerlayout>
          <!-- <p>{{ "Hello" }}</p> -->
        </b-col>
      </b-row>
      <b-row class="form-white-bg h-100 overflow-auto">
        <b-form class="w-100 px-2 d-flex flex-column position-relative" @submit.prevent="IsSubmit">
          <b-row>
            <b-col lg="7" md="6" sm="8" cols="12" class="py-3">
              <b-row>
                <b-col lg="6" md="6" sm="8" cols="12">
                  <div class="field">
                    <TextField v-model="insert_data.Code" type="text" placeholder="" clearable disabled
                      :label="$t('5003.itemid')" name="Code" :rules="{ required: true, alphanumeric: true }"
                      :required-icon="true" :tabindex="1" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6" md="6" sm="8" cols="12">
                  <div class="field">
                    <TextField v-model="insert_data.ProductId" type="text" placeholder="" clearable disabled
                      :label="$t('5003.productid')" name="Product Id" :rules="{ required: true, alphanumeric: true }"
                      :required-icon="true" :tabindex="2" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="8" md="8" sm="8" cols="12">
                  <div class="field">
                    <TextField v-model="insert_data.Name" type="text" placeholder="" clearable
                      :label="$t('5003.itemname')" name="Name" :rules="{ required: true }" :required-icon="true"
                      :tabindex="3" case="Capital" :autofocus="true" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-row>
                  <b-col lg="6" md="4" sm="10" cols="12" class="addcircle_field">
                    <div class="field">
                      <CustomDropDown v-model="insert_data.HSNId" :items="HSNDropdown.HSNoption" @change="HSNOnChange"
                        :label="$t('5003.hsn')" name="HSN" :rules="{ required: true }" :required-icon="true"
                        :tabindex="4" />
                    </div>
                    <span class="add_circle" @click="FunctionRights(EntityIds.HSN, 'HSN')"><i
                        class="pi pi-plus"></i></span>
                  </b-col>
                  <b-col lg="3" md="4" sm="10" cols="12">
                    <div class="field mt-2">
                      <label> {{ $t("5003.purchasetax") }}</label>
                      <p>{{ HSNDropdown.Ptax }}</p>
                    </div>
                  </b-col>
                  <b-col lg="3" md="4" sm="10" cols="12">
                    <div class="field mt-2">
                      <label>{{ $t("5003.salestax") }}</label>
                      <p>{{ HSNDropdown.Stax }}</p>
                    </div>
                  </b-col>
                  <!-- <b-col lg="3" md="4" sm="8" cols="12">
              <n-form-item path="Itemname">
                <n-input placeholder="" />
              </n-form-item>
            </b-col> -->
                </b-row>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <TextField v-model="insert_data.PurchasePrice" placeholder="" :label="$t('5003.purchaseprice')"
                        name="Purchase Price" id="Purchase Price" :rules="{
                          nonnegative: true,
                          required: true,
                          decimal: true,
                        }" :required-icon="true" :tabindex="5" />
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <TextField v-model="insert_data.SalesPrice" placeholder="" clearable label="Sales Price"
                        name="SalesPrice" id="SalesPrice" :rules="{
                          nonnegative: true,
                          required: false,
                          decimal: true,
                        }" :required-icon="false" :tabindex="6" />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <TextField v-model="insert_data.MRP" placeholder="" clearable :label="$t('5003.mrp')" name="MRP"
                        id="MRP" :rules="{
                          nonnegative: true,
                          required: false,
                          decimal: true,
                        }" :required-icon="false" :tabindex="7" />
                    </div>
                  </b-col>
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <TextField v-model="insert_data.MarkupPercentage" :label="$t('5003.markup')" name="Markup"
                        id="Markup" :rules="{ required: false, percentage: true }" :txttype="txttype" :tabindex="8" />
                    </div>
                  </b-col>
                </b-row>
              </b-row>
            </b-col>
            <b-col lg="4" md="6" sm="8" cols="12">
              <div class="me-2 my-5">
                <!-- <FileUpload /> -->
                <!-- <input type="file" @change="onFileSelected" /> -->

                <FileUpload uploadoption="imageupload" :imageData="imageData" @ImageURL="ImageURL"
                  :PorpsImageList="PorpsImageList" @deletedImageId="deletedImageId"></FileUpload>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6" md="6" sm="10" cols="12">
              <Grouping v-model="Grouping" :propsItemConfig="propsItemConfig" @ProductId="ProductId" />
            </b-col>
            <b-col lg="6" md="6" sm="10" cols="12">
              <Unitoftransactions v-model="Unitoftransactions" :PackSizeHide="false" ref="UnitoftransactionsRef" />

              <Manufacturing v-model="Manufacturing" />
              <Generic v-model="Generic" />
              <div class="field">
                <CustomDropDown v-model="insert_data.ItemClass" :items="ClassItemList" @change=""
                  :label="$t('5003.itemclass')" name="ItemClass" :rules="{ required: false }" :required-icon="false" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="10" cols="12">
              <SpecialCategory v-model:checked="SpecialCategory" />
            </b-col>
            <b-col lg="6" md="6" sm="10" cols="12">
              <Configuration v-model:checked="Configuration" />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <!-- <Footer @cancel="" type="submit" /> -->
              <Footer @cancel="IsClear()" :cancelhide="false" :label="label" :tabsave="40" :loading="Saveloading" />
            </b-col>
          </b-row>
        </b-form>
      </b-row>
    </b-container>

    <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
    <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
    <HSNCreation v-model:trigger="DialogShow.HSN" v-if="DialogShow.HSN" @load="LoadHSN(), (DialogShow.HSN = false)"
      @close="DialogShow.HSN = false" :OperationID="ObjOperationId" :EntityId="EntityIds.HSN" />
    <Mapping :visible="MappingPop.visible" @ok="MappingPop.visible = false" :content="MappingPop.content"
      :selectedcontent="MappingPop.selectedcontent" />

    <Toast />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, watch } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../components/GeneralButtons/SaveButton.vue";
import Unitoftransactions from "../../../../../../modules/Inventory/components/MasterCreation/UnitOfTransactions.vue";
import Grouping from "../../../../../../modules/Inventory/components/MasterCreation/Grouping.vue";
import Manufacturing from "../../../../../../modules/Inventory/components/MasterCreation/Manufacturing.vue";
import Generic from "../../../../../../modules/Inventory/components/MasterCreation/Generic.vue";
import SpecialCategory from "../../../../../../modules/Inventory/components/MasterDetails/SpecialCategory.vue";
import Configuration from "../../../../../../modules/Inventory/components/MasterCreation/Configuration.vue";
import FileUpload from "../../../../../../modules/Inventory/components/MasterCreation/FileUpload.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/ItemMasService";
import { useRoute, useRouter } from "vue-router";
import FileUploadService from "../../../../Service/SupplierMaster";
import common from "../../../../Service/CommonService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import { useForm } from "vee-validate";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
import { useI18n } from "vue-i18n";
import HSNCreation from "../../../../../../modules/Inventory/pages/Masters/Tax/HSN/HSNCreation.vue";
import MastersService from "../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";

export default defineComponent({
  components: {
    AlreadyExist,
    BacktoPage,
    Headerlayout,
    Cancel,
    Save,
    Unitoftransactions,
    Grouping,
    Manufacturing,
    Generic,
    SpecialCategory,
    Configuration,
    FileUpload,
    axios,
    useRoute,
    TextField,
    CustomDropDown,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    HSNCreation,
    Mapping,
  },

  setup(props, { emit }) {
    debugger;
    let session: any = localStorage.getItem("UsersData");
    const toast = useToast();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const alreadyexistpop = ref(false);
    const txttype = ref("number");
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const route = useRoute();
    const redirectrouter = useRouter();
    const UpdateId = route.query;
    const EditId = route.query.id;
    const OperationId: any = ref(route.query.OperationId);
    const successpop = ref(false);
    const updatepop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let loading = ref(false);
    let Saveloading = ref(false);
    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    const MappingPop = ref({
      visible: false,
      content: "",
      selectedcontent: "Selected Item Already Mapped with",
    });
    let insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      Code: "",
      ProductId: "",
      Name: "",
      HSNId: ref(),
      PurchasePrice: ref(),
      MRP: ref(),
      MarkupPercentage: ref(),
      StandardRate: 0,
      SalesPrice: ref(),
      VatOn: "",
      IsNoBarcode: true,
      ScheduledInvItemId: 0,
      IsCAPEX: true,
      EntityId: 0,
      EntityOperationId: 0,
      ItemClass: ref(),
    });

    const Unitoftransactions: any = ref({
      PackSizeId: ref(),
      OrderUnitId: ref(),
      UnitId: ref(),
      DispenseInNumber: true,
      BaseUOMId: ref(),
    });

    const Grouping: any = ref({
      ItemTypeId: ref(),
      ItemGroupId: ref(),
      SubGroupId: ref(),
      // ProductId: ref(),
      Brand: "",
      ModelNumber: "",
      Size: "",
      ColdChain: "",
      AccountHeadId: ref(),
    });

    const propsItemConfig: any = ref({
      Brand: "",
      ModelNumber: "",
      Size: "",
    });

    const Manufacturing: any = ref({
      ManufatureId: ref(),
    });

    const Generic: any = ref({
      GenericId: ref(),
    });

    const SpecialCategory: any = ref({
      ScheduledItem: false,
      NarcoticItem: false,
      DrugFormulary: false,
      CriticalMedicine: false,
      Alike: false,
      SpecialCategoryItemId: ref() ?? 0,
    });

    const Configuration: any = ref({
      ExpiryDtRequired: false,
      BatchRequired: false,
      ManufactureDate: false,
      IsNonChargable: false,
      IsConsignee: false,
      NoMrp: false,
      AutoConsumed: false,
      HighValueFlag: false,
      IsxrayFilm: false,
      IsGSTExempt: false,
      Asset: false,
      ConfigValue: "",
      ServiceLevel: false,
      IsProduct: false,
      IsBrand: false,
      IsModel: false,
      IsSize: false,
      IsWorkOrder: false
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      HSN: false,
    });

    let EntityIds = ref({
      HSN: 113,
    });

    onMounted(async () => {
      debugger;
      document.addEventListener("keydown", onKeyUp);

      await LoadHSN();
      init();
    });

    let PorpsImageList: any = ref([]);
    let ProductTypeId = ref();
    async function init() {
      debugger;
      console.log(UpdateId.id);
      if (UpdateId.id != undefined) {
        try {
          label.value = t("btn.update");
          const EditID = UpdateId.id;
          console.log(EditID);
          try {
            loading.value = true;

            // Get edit data
            const data_response = await service.Edit(EditID, HospitalId);
            const data1 = data_response["result"];
            console.log(data_response["result"]);

            // First assign the main form data
            Object.keys(insert_data.value).forEach((key) => {
              if (data1[key] !== undefined) insert_data.value[key] = data1[key];
            });

            // Then assign Grouping data since it affects other dropdowns
            const groupingData = {
              ItemTypeId: data1.ItemTypeId ? Number(data1.ItemTypeId) : null,
              ItemGroupId: data1.ItemGroupId ? Number(data1.ItemGroupId) : null,
              SubGroupId: data1.SubGroupId ? Number(data1.SubGroupId) : null,
              Brand: data1.Brand || "",
              ModelNumber: data1.ModelNumber || "",
              Size: data1.Size || "",
              ColdChain: data1.ColdChain || "",
              AccountHeadId: data1.AccountHeadId
                ? Number(data1.AccountHeadId)
                : null,
            };

            // Update Grouping values and wait for dropdowns to load
            Object.assign(Grouping.value, groupingData);
            // await new Promise(resolve => setTimeout(resolve, 100)); // Small delay to ensure options are populated

            // // Store ItemTypeId for reference and update ProductId
            // ProductTypeId.value = groupingData.ItemTypeId;
            // insert_data.value.ProductId = data1.ProductId; // Preserve the original ProductId during edit

            // Assign UnitOfTransactions data
            const unitData = {
              PackSizeId: data1.PackSizeId ? Number(data1.PackSizeId) : null,
              OrderUnitId: data1.OrderUnitId ? Number(data1.OrderUnitId) : null,
              UnitId: data1.UnitId ? Number(data1.UnitId) : null,
              BaseUOMId: data1.BaseUOMId ? Number(data1.BaseUOMId) : null,
              DispenseInNumber:
                data1.DispenseInNumber !== undefined
                  ? data1.DispenseInNumber
                  : true,
            };

            // Update UnitOfTransactions values
            Object.assign(Unitoftransactions.value, unitData);

            // Update propsItemConfig values
            propsItemConfig.value = {
              Brand: data1.Brand || "",
              ModelNumber: data1.ModelNumber || "",
              Size: data1.Size || "",
            };

            // // Call HSNOnChange to update tax values
            // HSNOnChange();

            ProductTypeId.value = Grouping.value.ItemTypeId;

            Object.keys(Manufacturing.value).forEach((key) => {
              if (data1[key]) Manufacturing.value[key] = data1[key];
            });

            Object.keys(Generic.value).forEach((key) => {
              if (data1[key]) Generic.value[key] = data1[key];
            });

            Object.keys(SpecialCategory.value).forEach((key) => {
              if (key == "ScheduledItem") {
                if (data1.ScheduledItem == true) {
                  data1.ScheduledItem = ["true"];
                } else {
                  data1.ScheduledItem = [];
                }
              } else if (key == "NarcoticItem") {
                if (data1.NarcoticItem == true) {
                  data1.NarcoticItem = ["true"];
                } else {
                  data1.NarcoticItem = [];
                }
              } else if (key == "DrugFormulary") {
                if (data1.DrugFormulary == true) {
                  data1.DrugFormulary = ["true"];
                } else {
                  data1.DrugFormulary = [];
                }
              } else if (key == "CriticalMedicine") {
                if (data1.CriticalMedicine == true) {
                  data1.CriticalMedicine = ["true"];
                } else {
                  data1.CriticalMedicine = [];
                }
              } else if (key == "Alike") {
                if (data1.Alike == true) {
                  data1.Alike = ["true"];
                } else {
                  data1.Alike = [];
                }
              }
              if (data1[key]) SpecialCategory.value[key] = data1[key];
            });

            // Object.keys(Configuration.value).forEach((key) => {
            //   if (data1[key]) Configuration.value[key] = data1[key];
            // });

            Object.keys(Configuration.value).forEach((key) => {
              if (key == "ExpiryDtRequired") {
                if (data1.ExpiryDtRequired == true) {
                  data1.ExpiryDtRequired = ["true"];
                } else {
                  data1.ExpiryDtRequired = [];
                }
              } else if (key == "BatchRequired") {
                if (data1.BatchRequired == true) {
                  data1.BatchRequired = ["true"];
                } else {
                  data1.BatchRequired = [];
                }
              } else if (key == "IsNonChargable") {
                if (data1.IsNonChargable == true) {
                  data1.IsNonChargable = ["true"];
                } else {
                  data1.IsNonChargable = [];
                }
              } else if (key == "IsConsignee") {
                if (data1.IsConsignee == true) {
                  data1.IsConsignee = ["true"];
                } else {
                  data1.IsConsignee = [];
                }
              } else if (key == "NoMrp") {
                if (data1.NoMrp == true) {
                  data1.NoMrp = ["true"];
                } else {
                  data1.NoMrp = [];
                }
              } else if (key == "AutoConsumed") {
                if (data1.AutoConsumed == true) {
                  data1.AutoConsumed = ["true"];
                } else {
                  data1.AutoConsumed = [];
                }
              } else if (key == "HighValueFlag") {
                if (data1.HighValueFlag == true) {
                  data1.HighValueFlag = ["true"];
                } else {
                  data1.HighValueFlag = [];
                }
              } else if (key == "IsxrayFilm") {
                if (data1.IsxrayFilm == true) {
                  data1.IsxrayFilm = ["true"];
                } else {
                  data1.IsxrayFilm = [];
                }
              } else if (key == "IsGSTExempt") {
                if (data1.IsGSTExempt == true) {
                  data1.IsGSTExempt = ["true"];
                } else {
                  data1.IsGSTExempt = [];
                }
              } else if (key == "Asset") {
                if (data1.Asset == true) {
                  data1.Asset = ["true"];
                } else {
                  data1.Asset = [];
                }
              } else if (key == "ServiceLevel") {
                if (data1.ServiceLevel == true) {
                  data1.ServiceLevel = ["true"];
                } else {
                  data1.ServiceLevel = [];
                }
              } else if (key == "ManufactureDate") {
                if (data1.ManufactureDate == true) {
                  data1.ManufactureDate = ["true"];
                } else {
                  data1.ManufactureDate = [];
                }
              } else if (key == "IsProduct") {
                if (data1.IsProduct == true) {
                  data1.IsProduct = ["true"];
                } else {
                  data1.IsProduct = [];
                }
              } else if (key == "IsBrand") {
                if (data1.IsBrand == true) {
                  data1.IsBrand = ["true"];
                } else {
                  data1.IsBrand = [];
                }
              } else if (key == "IsModel") {
                if (data1.IsModel == true) {
                  data1.IsModel = ["true"];
                } else {
                  data1.IsModel = [];
                }
              } else if (key == "IsSize") {
                if (data1.IsSize == true) {
                  data1.IsSize = ["true"];
                } else {
                  data1.IsSize = [];
                }
              }
              else if (key == "IsWorkOrder") {
                if (data1.IsWorkOrder == true) {
                  data1.IsWorkOrder = ["true"];
                } else {
                  data1.IsWorkOrder = [];
                }
              }
              if (data1[key]) Configuration.value[key] = data1[key];
            });
            const ProductImageResponse = await common.GetProductImageByItemId(
              EditID
            );
            debugger;
            for (let item of ProductImageResponse["result"]) {
              PorpsImageList.value.push(item);
            }

            HSNOnChange();
            loading.value = false;
          } catch (error) {
            loading.value = false;
            alert(error);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        GetCode();
      }
    }

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
        redirectrouter.push({
          path: "/ItemMasterTableview",
        });
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      redirectrouter.push({
        path: "/ItemMasterTableview",
      });
      emit("load");
      IsClear();
    }
    // //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    const copyUnitoftransactions = JSON.parse(
      JSON.stringify(Unitoftransactions.value)
    );
    const copyGrouping = JSON.parse(JSON.stringify(Grouping.value));
    const copyManufacturing = JSON.parse(JSON.stringify(Manufacturing.value));
    const copyGeneric = JSON.parse(JSON.stringify(Generic.value));
    const copySpecialCategory = JSON.parse(
      JSON.stringify(SpecialCategory.value)
    );
    const copyConfiguration = JSON.parse(JSON.stringify(Configuration.value));

    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      Object.assign(Unitoftransactions.value, copyUnitoftransactions);
      Object.assign(Grouping.value, copyGrouping);
      Object.assign(Manufacturing.value, copyManufacturing);
      Object.assign(Generic.value, copyGeneric);
      Object.assign(SpecialCategory.value, copySpecialCategory);
      Object.assign(Configuration.value, copyConfiguration);
      GetCode();
    }

    let ClassItemList = [
      {
        value: 1,
        name: "Class A",
      },
      {
        value: 2,
        name: "Class B",
      },
      {
        value: 3,
        name: "Class C",
      },
    ];
    //Load HSN
    const HSNDropdown = ref({
      HSNid: null,
      HSNoption: [],
      Ptax: 0,
      Stax: 0,
      Ptaxtype: "",
      Staxtype: "",
    });

    async function LoadHSN() {
      debugger;
      try {
        const response = await service.HSN(HospitalId);
        console.log("hsn", response);
        HSNDropdown.value.HSNoption = response["result"]
          .filter((f) => f.IsActive == true && f.OrganizationId == HospitalId)
          .map((item) => {
            item.name = item.Name + " - " + item.Code;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //HSN OnChange
    const HSNOnChange = () => {
      debugger;
      let hsndata: any = HSNDropdown.value.HSNoption.filter(
        (item: any) => item.Id == insert_data.value.HSNId
      );
      HSNDropdown.value.Ptax = hsndata[0]?.PurchasePercentage || 0;
      HSNDropdown.value.Stax = hsndata[0]?.SalesPercentage || 0;
      HSNDropdown.value.Ptaxtype = hsndata[0]?.PurchaseTaxName || "";
      HSNDropdown.value.Staxtype = hsndata[0]?.SalesTaxName || "";

      console.log(insert_data.value.HSNId);
      //insert_data.value.HSNId = value.value;
    };
    const ProductId = (value) => {
      debugger;
      // Always update ProductId when emitted from Grouping component
      if (value) {
        insert_data.value.ProductId = value;
        // Update reference for future comparisons
        ProductTypeId.value = Grouping.value.ItemTypeId;
      }
    };
    //Save and Update
    const IsSubmit = async () => {
      debugger;
      //loading.value = true;
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      insert_data.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      insert_data.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      insert_data.value.BranchId = BranchId;
      insert_data.value.HospitalId = HospitalId;
      insert_data.value.ModifiedBy = UserId;
      insert_data.value.CreatedBy = UserId;
      insert_data.value.EntityId = Number(Entitydata.value.EntityId);
      insert_data.value.EntityOperationId = Number(OperationId.value);
      insert_data.value.ItemClass = insert_data.value.ItemClass || 0;
      insert_data.value.MarkupPercentage = insert_data.value.MarkupPercentage
        ? insert_data.value.MarkupPercentage
        : 0;
      insert_data.value.SalesPrice =
        insert_data.value.SalesPrice == "" ? 0 : insert_data.value.SalesPrice;
      insert_data.value.MRP =
        insert_data.value.MRP == "" ? 0 : insert_data.value.MRP;
      insert_data.value.MarkupPercentage =
        insert_data.value.MarkupPercentage == ""
          ? 0
          : insert_data.value.MarkupPercentage;

      SpecialCategory.value.ScheduledItem = Boolean(
        SpecialCategory.value.ScheduledItem[0] ?? false
      );
      SpecialCategory.value.NarcoticItem = Boolean(
        SpecialCategory.value.NarcoticItem[0] ?? false
      );

      SpecialCategory.value.DrugFormulary = Boolean(
        SpecialCategory.value.DrugFormulary[0] ?? false
      );

      SpecialCategory.value.CriticalMedicine = Boolean(
        SpecialCategory.value.CriticalMedicine[0] ?? false
      );

      SpecialCategory.value.Alike = Boolean(
        SpecialCategory.value.Alike[0] ?? false
      );

      Configuration.value.ExpiryDtRequired = Boolean(
        Configuration.value.ExpiryDtRequired[0] ?? false
      );

      Configuration.value.BatchRequired = Boolean(
        Configuration.value.BatchRequired[0] ?? false
      );
      Configuration.value.ManufactureDate = Boolean(
        Configuration.value.ManufactureDate[0] ?? false
      );

      Configuration.value.IsNonChargable = Boolean(
        Configuration.value.IsNonChargable[0] ?? false
      );

      Configuration.value.IsConsignee = Boolean(
        Configuration.value.IsConsignee[0] ?? false
      );

      Configuration.value.NoMrp = Boolean(
        Configuration.value.NoMrp[0] ?? false
      );

      Configuration.value.AutoConsumed = Boolean(
        Configuration.value.AutoConsumed[0] ?? false
      );

      Configuration.value.HighValueFlag = Boolean(
        Configuration.value.HighValueFlag[0] ?? false
      );

      Configuration.value.IsxrayFilm = Boolean(
        Configuration.value.IsxrayFilm[0] ?? false
      );

      Configuration.value.IsGSTExempt = Boolean(
        Configuration.value.IsGSTExempt[0] ?? false
      );

      Configuration.value.Asset = Boolean(
        Configuration.value.Asset[0] ?? false
      );

      Configuration.value.IsProduct = Boolean(
        Configuration.value.IsProduct[0] ?? false
      );
      Configuration.value.ServiceLevel = Boolean(
        Configuration.value.ServiceLevel[0] ?? false
      );
      Configuration.value.IsBrand = Boolean(
        Configuration.value.IsBrand[0] ?? false
      );
      Configuration.value.IsModel = Boolean(
        Configuration.value.IsModel[0] ?? false
      );
      Configuration.value.IsSize = Boolean(
        Configuration.value.IsSize[0] ?? false
      );
      Configuration.value.IsWorkOrder = Boolean(
        Configuration.value.IsWorkOrder[0] ?? false
      );

      SpecialCategory.value.SpecialCategoryItemId =
        SpecialCategory.value.SpecialCategoryItemId == null
          ? 0
          : SpecialCategory.value.SpecialCategoryItemId;
      Grouping.value.AccountHeadId = !Grouping.value.AccountHeadId
        ? 0
        : Grouping.value.AccountHeadId;
      let objinsert = Object.assign(
        insert_data.value,
        Unitoftransactions.value,
        Grouping.value,
        Manufacturing.value,
        Generic.value,
        SpecialCategory.value,
        Configuration.value
      );

      console.log(objinsert);
      objinsert.GenericId =
        objinsert.GenericId == null ? 0 : objinsert.GenericId;
      try {
        let data_response: any;
        let msg = "";
        const updateid = UpdateId.id;
        if (updateid == undefined) {
          const data_response = await service.insert(objinsert);
          console.log(data_response);
          objinsert.Id = Number(data_response["result"]);
          msg = data_response["ErrorInfo"].ErrorCode;
          //loading.value = false;
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            // IsClear();
            Saveloading.value = false;
            successpop.value = true;
          }
        } else if (updateid != undefined) {
          const data_response = await service.Update(objinsert);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          if (DeletedImageIdArray.value.length > 0) {
            const DeletedImageResponse = await common.DeleteList(
              DeletedImageIdArray.value.join(",")
            );
          }
          // loading.value = false;
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (
            (data_response["result"] == "Ordering Unit" ||
              data_response["result"] == "Dispensing Unit") &&
            msg == null
          ) {
            Saveloading.value = false;
            MappingPop.value.content = data_response["result"];
            MappingPop.value.selectedcontent = "Cannot Change";
            MappingPop.value.visible = true;
          } else if (msg == null) {
            // IsClear();
            Saveloading.value = false;
            updatepop.value = true;
          }
        } else {
          Saveloading.value = false;
          console.log(updateid);
        }
        debugger;
        for (let item of ImageURLList.value) {
          if (!item["Id"]) {
            let Formdata = {
              CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
              CreatedBy: UserId,
              ModifiedBy: 0,
              ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
              HospitalId: objinsert.HospitalId,
              BranchId: objinsert.BranchId,
              Id: 0,
              EntityId: objinsert.EntityId,
              EntityOperationId: objinsert.EntityOperationId,
              ItemId: objinsert.Id,
              ImageFile: item["ImageFile"].split("/FileUpload/")[1],
            };
            const data_response = await common.CreateProductImageMAS(Formdata);
          }
        }
      } catch (error) {
        // loading.value = false;
        Saveloading.value = false;
        alert(error);
      }
    };

    //Get Auto generate Code
    async function GetCode() {
      debugger;
      let data = {
        // EntityId: Entitydata.value.EntityId,
        EntityId: 3006,

        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      insert_data.value.Code = result;
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      insert_data.value.Name = "";
      //showDialog.value = true
    }
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    let ImageURLList: any = ref([]);
    function ImageURL(value) {
      ImageURLList.value = value;
    }
    let DeletedImageIdArray = ref([]);
    function deletedImageId(value) {
      DeletedImageIdArray.value = value;
    }
    return {
      EditId,
      ObjOperationId,
      EntityIds,
      DialogShow,
      FunctionRights,
      alreadyexistpop,
      insert_data,
      Unitoftransactions,
      Grouping,
      Manufacturing,
      Generic,
      SpecialCategory,
      Configuration,
      HSNDropdown,
      LoadHSN,
      HSNOnChange,
      IsSubmit,
      IsClear,
      GetCode,
      successpop,
      updatepop,
      closetrigger,
      imageData: {
        src: "",
        alt: "example image",
      },
      alreadyclosetrigger,
      label,
      loading,
      txttype,
      ProductId,
      propsItemConfig,
      ClassItemList,
      ImageURL,
      ImageURLList,
      PorpsImageList,
      MappingPop,
      Saveloading,
      deletedImageId,
    };
  },

});
</script>
